import { useEffect, useState, useCallback } from "react";

export default function ScrollNav() {
  const [isLast, setIsLast] = useState(false);

  const getSections = useCallback(() => {
    return Array.from(document.querySelectorAll("section")).filter(
      (s) => s.getBoundingClientRect().height > 100
    );
  }, []);

  useEffect(() => {
    let raf: number;

    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const sections = getSections();
        if (sections.length === 0) return;

        // Last section's top is already above viewport bottom = reached end
        const lastRect = sections[sections.length - 1].getBoundingClientRect();
        const viewportBottom = window.innerHeight;
        setIsLast(lastRect.top + lastRect.height * 0.3 < viewportBottom);
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      cancelAnimationFrame(raf);
    };
  }, [getSections]);

  const scrollNext = () => {
    const sections = getSections();
    if (sections.length === 0) return;

    // Find the first section whose top is meaningfully below the viewport center
    const viewportCenter = window.scrollY + window.innerHeight / 2;

    for (const section of sections) {
      const rect = section.getBoundingClientRect();
      const sectionTop = window.scrollY + rect.top;
      // Section top is at least 80px below viewport center → scroll to it
      if (sectionTop > viewportCenter + 80) {
        const headerOffset = 80;
        const top = sectionTop - headerOffset;
        window.scrollTo({ top, behavior: "smooth" });
        return;
      }
    }
  };

  if (isLast) return null;

  return (
    <button
      onClick={scrollNext}
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] flex flex-col items-center gap-0.5 cursor-pointer group transition-all duration-500 hover:-translate-y-0.5"
      aria-label="Scroll to next section"
    >
      <span className="text-[8px] font-bold tracking-widest uppercase text-gray-800 group-hover:text-black transition-colors">Next</span>
      <div className="w-6 h-6 rounded-full border-[2px] border-black/80 bg-white flex items-center justify-center group-hover:border-black group-hover:bg-gray-50 shadow-md transition-all duration-300 animate-pulse-glow">
        <i className="ri-arrow-down-s-line text-black text-sm group-hover:text-black transition-colors duration-300" />
      </div>
    </button>
  );
}